import { Box } from "@mui/system";
import React from "react";

function TabPanel({ index, value, children }) {
  return <Box>{index === value && <>{children}</>}</Box>;
}

export default TabPanel;
